import styled from "@emotion/styled"
import AniLink from "gatsby-plugin-transition-link/AniLink"
import * as React from "react"
import Layout from "../components/layout"
import Seo from "../components/seo"
import StenaInfinityMax from "../images/Logo-Stena-Infinity-max.svg"
import { useStaticQuery, graphql} from "gatsby"


const StyledVideoBG = styled.div `
    height: 100vh;
    video {
        object-fit: cover;
        width: 100vw;
        height: calc(100vh - 70px);
        position: absolute;
        top: 56px;
        left: 0;
        z-index:200;
        @media only screen and (min-width: 768px) {
            top: 70px;
        }
    }
`

const VideoContent = styled.div `
    position:relative;
    height: 85vh;
    z-index:200;
    padding: 3% 3% 0 3%;
    h1 {
        color:white;
        letter-spacing: 1px;
        font-weight:500;
        text-shadow: 1px 8px 24px rgba(0,0,0,.4);
        @media only screen and (min-width: 768px) {
            max-width: 50%;
        }
    }
    h2 {
        color: rgba(255,255,255,.75);
        position: absolute;
        bottom: 20%;
        left: 5%;
        @media only screen and (min-width: 768px) {
            max-width: 50%;
            bottom: 5%;
            left: 3%;
        }
        @media only screen and (max-width: 767px) {
        font-size: 24px;
        }
    }
    .explore-btn {
        color: white;
        font-family: 'breuer_condensedmedium', sans-serif;
        font-weight: bold;
        text-transform: uppercase;
        text-rendering: optimizeLegibility;
        line-height: 1.1;
        letter-spacing: 1px;
        font-size: 32px;
        position: absolute;
        bottom: 5%;
        right: auto;
        left: 5%;
        @media only screen and (min-width: 768px) {
            font-size: 52px;
            bottom: 10%;
            right: 5%;
            left: auto;
        }
    }
`









const SubPage = () => {
  const queryRes = useStaticQuery(query);
  return (
  <Layout>
    <Seo title="Introducing the new Stena Infinity Max" />
    <StyledVideoBG>

        {/* <video src="/video/Infinity-full.mp4" autoPlay loop playsInline muted></video> */}
        <video src={queryRes.strapiGlobal?.introVideo?.url} autoPlay loop playsInline muted></video>
        <VideoContent>
            <img src={StenaInfinityMax} alt="Stena Infinity Max"/>
            
            <h2>{queryRes.strapiGlobal?.WatchVideoText} </h2>
            <AniLink cover bg="#00356c" to="/home" className="explore-btn">« Back</AniLink>
        </VideoContent>
    </StyledVideoBG>
    


    
    
  </Layout>
)
}
const query = graphql`
query {
  strapiGlobal {
    WatchVideoText
    introVideo {
      url
    }
  }
}`

export default SubPage
